import React, { MouseEventHandler } from 'react';
import './index.scss';

interface Props {
  steps: Array<string>;
  activeStep: number;
  handleStep?: (param: number) => MouseEventHandler<HTMLLIElement>;
}

export const Stepper = (props: Props) => {
  const { steps, activeStep, handleStep } = props;
  return (
    <div className="stepper_controller">
      <div className="card">
        <div className="card_content">
          <ul className="stepper_group test1">
            {steps &&
              steps.map((step: string, index: number) => (
                <li
                  data-testid={`step-item-${index}`}
                  onClick={handleStep?.(index)}
                  key={`step_${index}`}
                  className={activeStep === index ? 'status_current' : activeStep >= index ? 'status_success' : ''}
                >
                  <div className="inside_content">
                    <div className="count_number">
                      <span className="num_text">{index + 1}</span>
                    </div>
                    <div className="text_group">
                      <div className="step_title">{step}</div>
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default Stepper;
